import { render, staticRenderFns } from "./ItemSalesAverageReportPrint.vue?vue&type=template&id=875fa548&"
import script from "./ItemSalesAverageReportPrint.vue?vue&type=script&lang=js&"
export * from "./ItemSalesAverageReportPrint.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports